import { render, staticRenderFns } from "./slist.vue?vue&type=template&id=eff97d7a"
import script from "./slist.vue?vue&type=script&lang=js"
export * from "./slist.vue?vue&type=script&lang=js"
import style0 from "./slist.vue?vue&type=style&index=0&id=eff97d7a&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports